import { Controller } from "@hotwired/stimulus"

function removeButtonLoading(event) {
  if (event.target.id == 'products-form') {
    document.querySelector('#search-form input[type=submit]').classList.remove('loading');
  }
  if (event.target.id == 'orders-form') {
    document.querySelector('#search-form input[type=submit]').classList.remove('loading');
  }
}

// Connects to data-controller="search-form"
export default class extends Controller {
  static values = {
    options: Object,
  };

  connect() {
    addEventListener('turbo:submit-end', removeButtonLoading);
  }

  disconnect() {
    removeEventListener('turbo:submit-end', removeButtonLoading);
  }

  change(event) {
    const tab = event.target.dataset.tab;
    document.querySelector('#search-form input#filter_by').value = tab;
    document.querySelectorAll('#search-form a.tab-button').forEach(e => e.classList.remove('active'));
    document.querySelectorAll('#search-form form .form-input.active').forEach(e => e.classList.remove('active'));
    document.querySelector(`#search-form a[data-tab="${tab}"]`).classList.add('active');
    document.querySelectorAll(`#search-form form .form-field-${tab}`).forEach(e => e.classList.add('active'));
  }

  onAreaSelect(event) {
    const groupEl = document.querySelector('#search-form select#product_group');
    const subGroupEl = document.querySelector('#search-form select#product_sub_group');
    const area = this.optionsValue[event.target.value];
    if (!groupEl) return;

    groupEl.innerHTML = '';
    subGroupEl.innerHTML = '';
    const empty = document.createElement('option');
    empty.value = '';
    empty.innerHTML = 'Todos';
    groupEl.appendChild(empty);
    const emptyG = document.createElement('option');
    emptyG.value = '';
    emptyG.innerHTML = 'Todos';
    subGroupEl.appendChild(emptyG);

    if (area && area.groups) {
      Object.values(area.groups).forEach((group) => {
        const option = document.createElement('option');
        option.value = group.group[1];
        option.innerHTML = group.group[0];
        groupEl.appendChild(option);
      });
      groupEl.parentElement.classList.remove('inactive');
    } else {
      groupEl.parentElement.classList.add('inactive');
    }
    document.querySelector('#search-form select#product_sub_group').parentElement.classList.add('inactive');
  }

  onGroupSelect(event) {
    const groupEl = document.querySelector('#search-form select#product_sub_group');
    const area = parseInt(document.querySelector('#search-form select#product_area').value)
    const group = this.optionsValue[area]['groups'][event.target.value];
    if (!groupEl) return;

    groupEl.innerHTML = '';
    const empty = document.createElement('option');
    empty.value = '';
    empty.innerHTML = 'Todos';
    groupEl.appendChild(empty);

    if (group && group.subgroups) {
      Object.values(group.subgroups).forEach((group) => {
        const option = document.createElement('option');
        option.value = group[1];
        option.innerHTML = group[0];
        groupEl.appendChild(option);
      });
      groupEl.parentElement.classList.remove('inactive');
    } else {
      groupEl.parentElement.classList.add('inactive');
    }
  }

  onSearch(event) {
    event.target.classList.add('loading');
  }
}
